export default {
    required: '%{field} الزامی می‌باشد',
    invalid: '%{field} صحیح نمی‌باشد',
    min: 'حداقل %{min} کاراکتر',
    max: 'حداکثر %{max} کاراکتر',
    between: '%{field} باید بین %{min} و %{max} باشد!',
    sumBetween: "%{field} بین %{min} و %{max} باشد!",
    maxSum: "مجموع %{field} حداکثر %{max} !",
    minSum: "مجموع %{field} حداقل %{min} !",
    character: 'کاراکتر ',
    sameAs: '%{field} و %{current} یکسان نمی‌باشند.', 
    notSameAs: '%{field} و %{current} یکسان می‌باشند.',
    notZero: '%{field} نمیتواند صفر باشد.',
    cannotAddPatientInAddUser: 'امکان ثبت بیمار در این بخش وجود ندارد',
    nationalCode:'فرمت کدملی صحیح نیست'

}